import Box from '@redbubble/design-system/src/Box';
import React, { ReactNode } from 'react';
import styles from './Tab.module.scss';

interface TabProps {
  children?: ReactNode;
  active?: boolean;
  href?: string;
}

const Tab = ({ children, active, href }: TabProps) => {
  const classNames = [styles.container, active && styles.active]
    .filter(Boolean)
    .join(' ');

  return (
    <Box href={href} className={classNames}>
      {children}
    </Box>
  );
};

export default Tab;
